var map = {
	"./low-01.jpg": 59141,
	"./low-02.jpg": 54938,
	"./low-03.jpg": 26103,
	"./low-04.jpg": 36140,
	"./low-05.jpg": 91401,
	"./low-06.jpg": 11806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67090;